import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/ThreatTypes'
)

export const THREAT_TYPES = {
  businessEmailCompromise: 'Business Email Compromise',
  polymorphicPhishing: 'Polymorphic Phishing',
  bulkPhishing: 'Bulk Phishing',
  credentialTheft: 'Credential Theft',
  suspectedMaliciousContent: 'Suspected Malicious Content',
  financialFraud: 'Financial Fraud',
  advanceFeeScam: 'Advance-fee Scam',
  extortion: 'Extortion',
  vendorScam: 'Vendor Scam',
  vipImpersonation: 'VIP Impersonation',
  vishingAttack: 'Vishing Attack',
  invoicePhishing: 'Invoice Phishing',
  accountTakeover: 'Account Takeover (ATO)',
  vendorEmailCompromise: 'Vendor Email Compromise',
  imageBasedAttack: 'Image-Based Attack',
  qrCodeAttack: 'QR Code Attack',
  giftCardRequest: 'Gift Card Request',
  fraudelentRequest: 'Fraudulent Request',
}

export const THREATS_SHORT_DESCRIPTION = {
  [THREAT_TYPES.businessEmailCompromise]:
    'Business Email Compromise: a real internal/partner account is taken over and used in targeted attacks.',
  [THREAT_TYPES.polymorphicPhishing]:
    'Bulk phishing efforts usually feature messages that are broadly applicable and somewhat credible to a diverse audience. This type of phishing is a widespread issue across various sectors and continues to be a major point of concern in the field of cybersecurity',
  [THREAT_TYPES.bulkPhishing]: 'Non-targeted phishing, typically sent in large volume.',
  [THREAT_TYPES.credentialTheft]:
    'Attempts to steal usernames or passwords using fake login forms.',
  [THREAT_TYPES.suspectedMaliciousContent]:
    'Emails with dangerous links or attachments that install malware.',
  [THREAT_TYPES.financialFraud]: 'Deceives users into making unauthorized financial transactions.',
  [THREAT_TYPES.advanceFeeScam]: 'Promises money or rewards in exchange for an upfront payment.',
  [THREAT_TYPES.extortion]:
    'Threatens or blackmails the recipient, often claiming to have sensitive info.',
  [THREAT_TYPES.vendorScam]: 'Impersonation of a vendor to perform a deceptive scam.',
  [THREAT_TYPES.vipImpersonation]: 'Pretends to be a company executive or high-profile individual.',
  [THREAT_TYPES.vishingAttack]:
    'Voice-based phishing attacks using phone calls to deceive victims into revealing sensitive information or performing fraudulent actions',
  [THREAT_TYPES.invoicePhishing]:
    'Sends fake invoices to trick finance teams into transferring funds.',
  [THREAT_TYPES.accountTakeover]:
    "Account Takeover (ATO) involves cybercriminals gaining unauthorized access to a person's online accounts, often using stolen credentials obtained through phishing or other methods, enabling them to control the account, steal sensitive information, or carry out malicious activities in the victim's name.",
  [THREAT_TYPES.giftCardRequest]: 'Requests for gift cards impersonating a colleague or executive.',
  [THREAT_TYPES.vendorEmailCompromise]:
    'Vendor Email Compromise: a real vendor account is compromised and used in a scam.',
  [THREAT_TYPES.imageBasedAttack]: 'Uses images to conceal phishing content and bypass filters.',
  [THREAT_TYPES.qrCodeAttack]: 'QR codes that lead to phishing pages or malicious sites.',
  [THREAT_TYPES.fraudelentRequest]:
    'Deceptive and urgent requests meant to trick the user into action.',
}

export const fakeData = {
  total: 17,
  counts: [
    {
      name: THREAT_TYPES.vipImpersonation,
      value: 9,
      percentage: 47,
    },
    {
      name: THREAT_TYPES.businessEmailCompromise,
      value: 2,
      percentage: 11.76470588235294,
    },
    {
      name: THREAT_TYPES.credentialTheft,
      value: 2,
      percentage: 11.76470588235294,
    },
    {
      name: THREAT_TYPES.advanceFeeScam,
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: THREAT_TYPES.extortion,
      value: 1,
      percentage: 0.08235294117647,
    },
    {
      name: THREAT_TYPES.invoicePhishing,
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Lottery Scam', // ❗ Not in THREAT_TYPES
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: THREAT_TYPES.polymorphicPhishing,
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Scam Vendor', // ❗ Not in THREAT_TYPES
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Sextortion', // ❗ Not in THREAT_TYPES
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: THREAT_TYPES.suspectedMaliciousContent,
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: THREAT_TYPES.vendorEmailCompromise,
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: THREAT_TYPES.vishingAttack,
      value: 1,
      percentage: 5.88235294117647,
    },
  ],
}

export const THREATS_LOG_TYPES = ['Suspicious email detected', 'Suspicious email reported']

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'
export const NO_DATA_MESSAGE =
  'There are no threat types available to be shown within the chosen time frame at this moment.'
